import { animateElement, Duration } from 'utils/animateElement';

import { COLLAPSED_STYLE } from '../constants';
import { createExpandedStyle } from './createExpandedStyles';

export const animateCollapse = (
  element: HTMLElement,
  fromContentHeight: number,
  duration: Duration,
) => {
  const height = createExpandedStyle(fromContentHeight);
  return animateElement({ ...height, overflow: 'hidden' }, COLLAPSED_STYLE, element, duration);
};
